// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import VueLocalstorage from 'vue-localstorage';
import ElementUI from 'element-ui';
import GameNumber from '@/plugins/game_number';
import ShuffleCard from '@/plugins/shuffle_card';
import ShuffleImage from '@/plugins/shuffle_image';

import 'element-ui/lib/theme-chalk/index.css';

import App from './App';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(VueLocalstorage);
Vue.use(ElementUI);
Vue.use(GameNumber);
Vue.use(ShuffleCard);
Vue.use(ShuffleImage);

const r = router(store);
sync(store, r);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: r,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js